import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { resetStoriesStreamError } from "../../../actions/storiesStream";

class ScrollToTop extends Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.storiesStream.isError && nextProps.storiesStream.isError) {
      this.props.resetStoriesStreamError();
    }
  }

  componentDidUpdate(prevProps) {
    const prevLoc = prevProps.location;
    const loc = this.props.location;

    if (prevLoc.pathname !== loc.pathname || prevLoc.search !== loc.search) {
      setTimeout(window.scrollTo(0, 0), 300);
    }
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = (state) => {
  return {
    storiesStream: state.storiesStream,
  };
};

export default withRouter(connect(mapStateToProps, { resetStoriesStreamError })(ScrollToTop));



// WEBPACK FOOTER //
// ./src/components/Library/ScrollToTop/ScrollToTop.js